import styled from 'styled-components'
import { COLORS } from '@assets/styles/colors'

export const UploadContainer = styled.div`
	width: 100%;
	height: 314px;
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='30' ry='30' stroke='%23808AFF' stroke-width='4' stroke-dasharray='15 12' stroke-dashoffset='var(--dash-offset-start)' stroke-linecap='square'/%3e%3c/svg%3e");
	border-radius: 30px;
	display: flex;
	column-gap: 12px;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	transition: 17ms ease-in-out;
`

export const UploadButton = styled.button`
	padding: 10px 20px;
	font-size: 18px;
	cursor: pointer;
	border: none;
	background-color: ${COLORS.DECORATIVE_YELLOW};
	display: flex;
	column-gap: 12px;
	align-items: center;
	border-radius: 25px;

	& div {
		color: ${COLORS.DECORATIVE_MEDIUM_BLUE};
		font-weight: 600;
	}

	&:active {
		background-color: #eef965;
	}
`
